import React from 'react'
import clsx from 'clsx'
import GetAppIcon from '@material-ui/icons/GetApp'
import ErrorIcon from '@material-ui/icons/Error'
import Button from '../../Button/Button'
import CMSText from '../../Global/CMSText'
import { Fade, Typography, makeStyles, createStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) =>
  createStyles({
    error: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.error.main,
      marginBottom: theme.spacing(1),
      '&>svg': {
        marginRight: theme.spacing(1.5),
      },
    },
  })
)

type Tprops = {
  accountRes: any
  orderToken: string
  handleDownloadInvoice: (orderToken: string) => any
  t: any
  invoiceDownloadError: boolean
  isSub: boolean
}

const DownloadInvoiceButton = ({
  accountRes,
  orderToken,
  handleDownloadInvoice,
  t,
  invoiceDownloadError,
  isSub,
}: Tprops) => {
  const classes = useStyles()
  return (
    <>
      {!isSub && (
        <>
          <Button
            onClick={() => handleDownloadInvoice(orderToken)}
            data-testid={'invoice--download__button'}
            className={'invoice--download__button'}
          >
            <GetAppIcon
              fontSize="small"
              className={'invoice--download__icon'}
            />
            <CMSText
              asText
              data={accountRes?.data?.order_download_invoice}
              defaultText={t('texts:account:order_download_invoice')}
            />
          </Button>
          {invoiceDownloadError && (
            <Fade in>
              <Typography
                variant="body1"
                component="div"
                className={clsx('download__invoice__error', classes.error)}
              >
                <ErrorIcon color="inherit" fontSize="small" />
                <CMSText
                  data={accountRes?.data?.order_download_invoice_error}
                  defaultText={t('texts:account:order_download_invoice_error')}
                />
              </Typography>
            </Fade>
          )}
        </>
      )}
    </>
  )
}

export default DownloadInvoiceButton
